import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import TurnstileField from "../../components/public/TurnstileField";

const LOGO = "https://customer-assets.emergentagent.com/job_277e14a4-0f30-4a88-8c2a-65bd1a744cb8/artifacts/o7xpulnt_logo-horizontal-cecit-for-light-bg%20%282%29.png";

export default function CmsLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password, turnstileToken);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      // A failed attempt burns the Turnstile token — user must solve it again.
      setTurnstileToken("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cms-shell min-h-screen flex bg-gray-50">
      <div className="hidden lg:flex flex-1 bg-[#0F2040] text-white p-16 flex-col justify-between relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1582919534700-acf2374f10d3?auto=format&fit=crop&w=1600&q=80"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="relative z-10">
          <img src={LOGO} alt="CECIT" className="h-12 brightness-0 invert" />
        </div>
        <div className="relative z-10">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-cecit-gold mb-5">Backoffice CMS</p>
          <h1 className="font-serif text-5xl leading-[1.1] mb-5">
            Cámara Oficial de Comercio<br />de España en Tánger
          </h1>
          <p className="text-white/70 max-w-md">Plataforma de gestión de contenidos institucionales — desde 1886 al servicio de las empresas.</p>
        </div>
        <div className="relative z-10 text-xs text-white/40">© CECIT</div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-10 text-center">
            <img src={LOGO} alt="CECIT" className="h-10 mx-auto" />
          </div>
          <h2 className="text-2xl font-semibold text-[#0F2040] mb-2">Iniciar sesión</h2>
          <p className="text-sm text-gray-600 mb-8">Acceso restringido al equipo editorial.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="cms-login-form">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5 uppercase tracking-wider">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-200 focus:border-[#0F2040] outline-none"
                data-testid="cms-login-email"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5 uppercase tracking-wider">Contraseña</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-200 focus:border-[#0F2040] outline-none"
                data-testid="cms-login-password"
              />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="cms-login-error">{error}</p>}
            <TurnstileField action="login" onToken={setTurnstileToken} className="mt-1" />
            <button
              type="submit"
              disabled={loading}
              data-testid="cms-login-submit"
              className="w-full bg-[#C8102E] hover:bg-[#A30D25] disabled:opacity-50 text-white py-3.5 text-sm font-medium tracking-wider transition-colors"
            >
              {loading ? "..." : "ENTRAR"}
            </button>
          </form>
          <Link to="/" className="block text-center text-xs text-gray-500 hover:text-[#C8102E] mt-8">← Volver al sitio</Link>
        </div>
      </div>
    </div>
  );
}
